const ComplexMoveControl = (props) => {
  const { element } = props;
  const moveUnit = 10;

  const onClickLeftUp = (e) => {
    if (!element)
      return;

    let prevLeft = element.style.left.replace("px", "");
    element.style.left = (window.Number(prevLeft) + moveUnit) + "px";
  };

  const onClickLeftDown = (e) => {
    if (!element)
      return;

    let prevLeft = element.style.left.replace("px", "");
    element.style.left = (window.Number(prevLeft) - moveUnit) + "px";
  };

  const onClickTopUp = (e) => {
    if (!element)
      return;

    let prevTop = element.style.top.replace("px", "");
    element.style.top = (window.Number(prevTop) + moveUnit) + "px";
  };

  const onClickTopDown = (e) => {
    if (!element)
      return;

    let prevTop = element.style.top.replace("px", "");
    element.style.top = (window.Number(prevTop) - moveUnit) + "px";
  };

  return (
    <div style={{ padding: 10, marginBottom: 10, display: "inline-block", background: "#fff", border: "1px solid #000" }}>
      <button className={"btn btn-sm btn-dark"} onClick={onClickTopDown}>+</button>
      <br />
      <button className={"btn btn-sm btn-dark"} onClick={onClickLeftDown}>{"<"}</button>
      <button className={"btn btn-sm btn-dark"} style={{ margin: 1 }} onClick={onClickTopUp}>-</button>
      <button className={"btn btn-sm btn-dark"} onClick={onClickLeftUp}>{">"}</button>
    </div>
  );
};

export { ComplexMoveControl };
